import { Skeleton } from '@/components/ui/skeleton';
import { Columns, RequestBar, SkeletonBody, SkeletonPane, PlaygroundFooter } from './styled';

const PlaygroundSkeleton = () => (
    <SkeletonBody role="status" aria-label="Loading playground">
        <RequestBar>
            <Skeleton className="h-[22px] w-14" />
            <Skeleton className="h-3 flex-1" />
            <Skeleton className="h-[22px] w-16" />
        </RequestBar>
        <Columns>
            <SkeletonPane>
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-8 w-full" />
                <Skeleton className="h-8 w-full" />
                <Skeleton className="h-32 w-full" />
            </SkeletonPane>
            <SkeletonPane>
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-40 w-full" />
            </SkeletonPane>
        </Columns>
        <PlaygroundFooter>
            <Skeleton className="h-3 w-40" />
            <Skeleton className="h-3 w-24" />
        </PlaygroundFooter>
    </SkeletonBody>
);

export default PlaygroundSkeleton;
